/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import { injectable } from 'inversify'
import { IBatchesApiClient } from './contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import { ICoverageDiscoveryBatchHistoryGrid, ICoverageDiscoveryBatchHistoryGridCriteria, ICoverageDiscoveryBatchHistoryGridResults, IOwnerUser } from '../BatchesStateManager/contracts'

@injectable()
export class MockBatchesApiClient implements IBatchesApiClient {
	public items: ICoverageDiscoveryBatchHistoryGrid[] = []
	apiBaseUrl: string
	constructor() {
		this.apiBaseUrl = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}`

		for (let x = 1; x <= 100; x++) {
			this.items.push({
				batchId: x,
				ownerId: x,
				ownerName: `Owner${x}`,
				batchRunStatusId: x,
				batchData: {
					batchName: `batch${x}`,
					percentageComplete: 30,
					transactionStatusIds: [1, 2, 3, 4],
					totalTransactionsCount: Math.round((Math.random() * 1000) % 800),
					pendingTransactionsCount: Math.round((Math.random() * 100) % 40),
					completeTransactionsCount: Math.round((Math.random() * 100) % 50),
					errorTransactionsCount: Math.round((Math.random() * 100) % 90),
					timedOutTransactionsCount: Math.round((Math.random() * 100) % 70),
					processingTransactionsCount: Math.round((Math.random() * 100) % 70),
					coverageFoundCount: Math.round((Math.random() * 1000) % 800),
				},
				batchRunId: x,
				runDate: new Date(2020, 1, 1, Math.round((Math.random() * 500) % 500), Math.round((Math.random() * 1000) % 1000), 0, 0),
			})
		}
	}

	getAllBatchOwners(): Promise<IOwnerUser[]> {
		return new Promise<IOwnerUser[]>(resolve =>
			resolve([
				{ id: 1, name: 'Owneradfdfgfgggg1', isSelected: false },
				{ id: 2, name: 'Owner2sfgsfgfgf', isSelected: false },
				{ id: 3, name: 'Ownersfgff3  vwdeegfeqfgeqfe qdvbqdvdvfe', isSelected: false },
				{ id: 4, name: 'Owner4', isSelected: false },
				{ id: 5, name: 'Owner5', isSelected: false },
				{ id: 6, name: 'Owner6', isSelected: false },
				{ id: 7, name: 'Owner7', isSelected: false },
				{ id: 8, name: 'Owner8', isSelected: false },
				{ id: 9, name: 'Owner9', isSelected: false },
				{ id: 10, name: 'Owner10', isSelected: false },
				{ id: 11, name: 'Owner12', isSelected: false },
				{ id: 12, name: 'Owner13', isSelected: false },
				{ id: 13, name: 'Owner14', isSelected: false },
				{ id: 14, name: 'Owner15', isSelected: false },
				{ id: 15, name: 'Owner16', isSelected: false },
			]),
		)
	}

	deleteSelectedRecord(): Promise<void> {
		return new Promise<void>(resolve => {
			setTimeout(() => resolve(), 100)
		})
	}

	list(criteria: ICoverageDiscoveryBatchHistoryGridCriteria): Promise<ICoverageDiscoveryBatchHistoryGridResults> {
		const result: ICoverageDiscoveryBatchHistoryGridResults = {
			items: this.items.slice(),
			total: 0,
		}

		if (criteria.searchTerm) {
			if (criteria.searchTerm.runDate) {
				const year = criteria.searchTerm.runDate.getFullYear()
				const month = criteria.searchTerm.runDate.getMonth()
				const day = criteria.searchTerm.runDate.getDate()
				if (criteria.dateRange === 0) {
					result.items = result.items.filter(x => x.runDate.getDate() === day && x.runDate.getMonth() === month && x.runDate.getFullYear() === year)
				}

				if (criteria.dateRange === 1) {
					result.items = result.items.filter(x => x.runDate.getDate() <= day + 1 && x.runDate.getDate() >= day - 1)
				}
				if (criteria.dateRange === 2) {
					result.items = result.items.filter(x => x.runDate.getDate() <= day + 7 && x.runDate.getDate() >= day - 7)
				}
				if (criteria.dateRange === 3) {
					result.items = result.items.filter(x => x.runDate.getDate() <= day + 14 && x.runDate.getDate() >= day - 14)
				}
				if (criteria.dateRange === 4) {
					result.items = result.items.filter(x => x.runDate.getMonth() <= month + 1 && x.runDate.getMonth() >= month - 1)
				}
				if (criteria.dateRange === 5) {
					result.items = result.items.filter(x => x.runDate.getMonth() <= month + 6 && x.runDate.getMonth() >= month - 6)
				}
				if (criteria.dateRange === 6) {
					result.items = result.items.filter(x => x.runDate.getFullYear() <= year + 1 && x.runDate.getFullYear() >= year - 1)
				}
			}

			if (criteria.searchTerm.ownerUsers) {
				if (criteria.searchTerm.ownerUsers.length !== 0) {
					const ids = criteria.searchTerm.ownerUsers.map(function(item) {
						return item.id
					})
					result.items = result.items.filter(x => ids.indexOf(x.ownerId) !== -1)
				}
			}

			if (criteria.searchTerm.transactionStatuses) {
				if (criteria.searchTerm.transactionStatuses.length !== 0) {
					const ids = criteria.searchTerm.transactionStatuses.map(function(item) {
						return item.id
					})
					result.items = result.items.filter(x => ids.indexOf(x.batchData.transactionStatusIds[0]) !== -1)
				}
			}
		}
		// sort
		const sortFunction = (x: ICoverageDiscoveryBatchHistoryGrid, y: ICoverageDiscoveryBatchHistoryGrid): number => {
			const getter = (i: ICoverageDiscoveryBatchHistoryGrid): any => {
				if ((criteria.sortField = 'ownerId')) {
					return i.ownerId
				} else if (criteria.sortField === 'runDate') {
					return i.runDate
				} else if (criteria.sortField === 'batchData') {
					return i.batchId
				} else {
					throw new Error(`Unsupported sort column: [${criteria.sortField}]`)
				}
			}
			const xVal = getter(x)
			const yVal = getter(y)
			if (xVal === yVal) {
				return 0
			} else if (xVal < yVal) {
				return criteria.sortOrder === 'asc' ? -1 : 1
			} else {
				return criteria.sortOrder === 'asc' ? 1 : -1
			}
		}

		result.items.sort(sortFunction)
		result.total = result.items.length
		// paging
		result.items = result.items.slice((criteria.page - 1) * criteria.sizePerPage, (criteria.page - 1) * criteria.sizePerPage + criteria.sizePerPage)
		return new Promise<ICoverageDiscoveryBatchHistoryGridResults>(resolve => {
			setTimeout(() => resolve(result), 100)
		})
	}
}
